import { Navigate } from "react-router-dom";

// Authentication
import Fourzerofour from "pages/AuthenticationInner/Errors/404Error";
import Fivezerozero from "pages/AuthenticationInner/Errors/500Error";
import Fivezerothree from "pages/AuthenticationInner/Errors/503Error";
import OfflinePage from "pages/AuthenticationInner/Errors/Offline";


import Ecommerce from "pages/Dashboard/Ecommerce";

// Authentication
import Login from "pages/Authentication/Login";
import Logout from "pages/Authentication/Logout";
import Register from "pages/Authentication/Register";
import ForgotPassword from "pages/Authentication/ForgotPassword";
import UserProfile from "pages/Authentication/user-profile";
import WeeklyReportsPage from "pages/WeeklyReports";
import WeeklyReportDetailPage from "pages/WeeklyReports/detail";
import BannerManagement from "pages/BannerManagement";
import TournamentDetails from "pages/TournamentDetails";
import TournamentDetailsPage from '../pages/TournamentDetails/components/TournamentDetailsPage';
import TournamentsPage from "pages/Tournaments";
import TournamentDetail from "pages/Tournaments/TournamentDetail";
import TeamRegistration from "pages/Tournaments/TeamRegistration";
import PlayerManagement from "pages/Tournaments/PlayerManagement";
import PaymentPage from "pages/Tournaments/PaymentPage";

import BlogCategoriesPage from "pages/BlogDetails/Categories";
import BlogsPage from "pages/BlogDetails/Blogs";
import BlogDetails from "pages/BlogDetails/Blogs/BlogDetails";
import NewsArticleList from "pages/NewsArticle/NewsArticleList";
import NewsArticleDetails from "pages/NewsArticle/NewsArticleDetails";

// Community Pages
import CommunityListPage from "pages/Community/CommunityListPage";
import CommunityCategoryPage from "pages/Community/CommunityCategoryPage";
import CommunityVideoDetailPage from "pages/Community/CommunityVideoDetailPage";

// Feature Management Pages
import FeaturesListPage from "pages/FeatureManagement/Features";
import FeatureDetailPage from "pages/FeatureManagement/Features/FeatureDetailPage";
import FeatureTogglesListPage from "pages/FeatureManagement/FeatureToggles";
import FeatureToggleDetailPage from "pages/FeatureManagement/FeatureToggles/FeatureToggleDetailPage";

// Shop Services Pages
import SellersPage from "pages/ShopServices/Sellers";
import SellerDetailPage from "pages/ShopServices/Sellers/SellerDetail";
import OrdersPage from "pages/ShopServices/Orders";
import OrderDetail from "pages/ShopServices/Orders/OrderDetail";
import ReturnDetail from "pages/ShopServices/Orders/ReturnDetail";
import CancelDetail from "pages/ShopServices/Orders/CancelDetail";
import SellerLocationDetailPage from "pages/ShopServices/Sellers/SellerLocationDetail";
import ProductsPage from "pages/ShopServices/Products";
import ProductDetail from "pages/ShopServices/Products/ProductDetail";

// Promos Pages
import CampaignsPage from "pages/Promos/Campaigns";
import CreateCampaign from "pages/Promos/Campaigns/CreateCampaign";
import CampaignDetailPage from "pages/Promos/Campaigns/CampaignDetail";
import PromosPage from "pages/Promos/Promos";
import CreatePromo from "pages/Promos/Promos/CreatePromo";
import PromoDetailPage from "pages/Promos/Promos/PromoDetail";
import AuditLogsPage from "pages/Promos/AuditLogs";

// Ads Pages
import AdsOverviewPage from "pages/Ads/Overview";
import AdsAdvertisersPage from "pages/Ads/Advertisers";
import AdsCampaignsPage from "pages/Ads/Campaigns";
import AdsCreateCampaignPage from "pages/Ads/Campaigns/CreateCampaign";
import AdsCreativesPage from "pages/Ads/Creatives";
import AdsAdPerformancePage from "pages/Ads/Creatives/AdPerformance";
import AdsPlacementsPage from "pages/Ads/Placements";
import AdsReportsPage from "pages/Ads/Reports";
import AdsBillingPage from "pages/Ads/Billing";
import AdsAuditLogsPage from "pages/Ads/AuditLogs";
import TournamentVideoDetailPage from "pages/ManageTournamentsFixtures/Videos/VideoDetail";
import GalleryAlbumDetailPage from "pages/ManageTournamentsFixtures/Gallery/AlbumDetail";
import BadmintonTiesPage from "pages/ManageTournamentsFixtures/Ties/BadmintonTiesPage";

// My Club Pages
import MyClub from "pages/MyClub";
import TeamInformation from "pages/MyClub/TeamInformation";
import TeamDetail from "pages/MyClub/TeamInformation/TeamDetail";
import PlayerInformation from "pages/MyClub/PlayerInformation";
import AddPlayer from "pages/MyClub/PlayerInformation/AddPlayer";
import PlayerDetail from "pages/MyClub/PlayerInformation/PlayerDetail";
import ClubInformation from "pages/MyClub/ClubInformation";

// Access Management Pages
import AccessManagementUsersPage from "pages/AccessManagement/Users";
import AccessManagementRolesPage from "pages/AccessManagement/Roles";
import AccessManagementPermissionsPage from "pages/AccessManagement/Permissions";
import AccessManagementAuditLogsPage from "pages/AccessManagement/AuditLogs";

// Academy Enrolments Pages
import AcademyEnrolmentsPage from "pages/AcademyEnrolments/Enrolments";
import AddEnrolmentPage from "pages/AcademyEnrolments/AddEnrolment";
import EnrolmentDetailsPage from "pages/AcademyEnrolments/EnrolmentDetails";
import AddTrialPage from "pages/AcademyEnrolments/AddTrial";
import { TRIALS_MANAGE_PERMS } from "pages/AcademyEnrolments/permissions";
import CourseAssignmentsPage from "pages/AcademyCourseAssignments";

// Player Vault Pages
import ClaimRequestsPage from "pages/PlayerVault/ClaimRequests";

// All Clubs Pages
import AllClubs from "pages/AllClubs";
import AddClubDetails from "pages/AllClubs/AddClubDetails";
import ClubDetails from "pages/AllClubs/ClubDetails";
import ClubPlayerManagement from "pages/AllClubs/ClubDetails/TeamManagement/PlayerManagement";

// Manage Players
import ManagePlayers from "pages/ManagePlayers";
import ManagePlayerDetail from "pages/ManagePlayers/PlayerDetail";

// Manage Tournaments
import ManageTournaments from "pages/ManageTournaments/ManageTournaments";
import TournamentDetailView from "pages/ManageTournaments/TournamentDetailView";
import SportsManagement from "pages/SportsManagement";

// Registered Tournaments
import RegisteredTournaments from "pages/RegisteredTournaments";
import RegisteredTournamentDetail from "pages/RegisteredTournaments/RegisteredTournamentDetail";
import RecordPaymentPage from "pages/RegisteredTournaments/RecordPaymentPage";

// Payment & Transactions
import PaymentTransactions from "pages/PaymentTransactions";
import Dues from "pages/PaymentTransactions/Dues";
import DueDetail from "pages/PaymentTransactions/Dues/DueDetail";
import Transactions from "pages/PaymentTransactions/Transactions";

// Super Admin Payments & Transactions
import SuperAdminPayments from "pages/SuperAdminPayments";

// Fixtures
import AddFixturePage from "../pages/Fixtures/AddFixturePage";
import GroupFixturesEditPage from "../pages/Fixtures/GroupFixturesEditPage";
import AddGroupPage from "pages/Fixtures/AddGroupPage";
import GroupDetailsPage from "pages/Fixtures/GroupDetailsPage";
import AddIndividualFixturesPage from "../pages/Fixtures/AddIndividualFixturesPage";
import AgeCategoryListingPage from "../pages/Fixtures/AgeCategoryListingPage";
import AddAgeCategoryFixturePage from "../pages/Fixtures/AddAgeCategoryFixturePage";

// Manage Tournaments Fixtures
import ManageTournamentsFixturesPage from "../pages/ManageTournamentsFixtures/ManageTournamentsFixturesPage";
import TournamentDetailPage from "../pages/ManageTournamentsFixtures/TournamentDetailPage";
import SeasonsListingPage from "../pages/ManageTournamentsFixtures/SeasonsListingPage";
import SeasonDetailPage from "../pages/ManageTournamentsFixtures/SeasonDetailPage";

// Standings Detail Pages
import SingleStandingsDetailPage from "../pages/ManageTournamentsFixtures/SingleStandingsDetailPage";
import GroupStandingsDetailPage from "../pages/ManageTournamentsFixtures/GroupStandingsDetailPage";
import GroupDetailPage from "../pages/ManageTournamentsFixtures/GroupDetailPage";
import KnockoutsDetailPage from "../pages/ManageTournamentsFixtures/KnockoutsDetailPage";
import PlayerStatsDetailPage from "../pages/ManageTournamentsFixtures/PlayerStatsDetailPage";
import MatchDetailPage from "../pages/ManageTournamentsFixtures/MatchDetailPage";

// Role-based Dashboard
import RoleBasedDashboard from "components/RoleBasedDashboard";
import ProtectedRoute from "components/ProtectedRoute";

const authProtectedRoutes = [
    // Dashboard - Role-based
    { path: "/dashboard", component: <RoleBasedDashboard /> },
    
    // Admin-only routes (protected)
    { path: "/WeeklyReports", component: <ProtectedRoute requiredModule="weeklyreports"><WeeklyReportsPage /></ProtectedRoute> },
    { path: "/WeeklyReports/detail", component: <ProtectedRoute requiredModule="weeklyreports"><WeeklyReportDetailPage /></ProtectedRoute> },
    { path: "/banner-management", component: <ProtectedRoute requiredModule="bannermanagement"><BannerManagement /></ProtectedRoute> },
    { path: "/blog-details/categories", component: <ProtectedRoute requiredModule="blogdetails"><BlogCategoriesPage /></ProtectedRoute> },
    { path: "/blog-details/blogs", component: <ProtectedRoute requiredModule="blogdetails"><BlogsPage /></ProtectedRoute> },
    { path: "/blog-details/blogs/add", component: <ProtectedRoute requiredModule="blogdetails"><BlogDetails /></ProtectedRoute> },
    { path: "/blog-details/blogs/:id", component: <ProtectedRoute requiredModule="blogdetails"><BlogDetails /></ProtectedRoute> },
    { path: "/news-articles", component: <ProtectedRoute requiredModule="newsarticles"><NewsArticleList /></ProtectedRoute> },
    { path: "/news-articles/add", component: <ProtectedRoute requiredModule="newsarticles"><NewsArticleDetails /></ProtectedRoute> },
    { path: "/news-articles/:id", component: <ProtectedRoute requiredModule="newsarticles"><NewsArticleDetails /></ProtectedRoute> },
    
    // Community routes (super-admin only)
    { path: "/community", component: <ProtectedRoute requiredModule="community"><CommunityListPage /></ProtectedRoute> },
    { path: "/community/:category", component: <ProtectedRoute requiredModule="community"><CommunityCategoryPage /></ProtectedRoute> },
    { path: "/community/:category/:videoId", component: <ProtectedRoute requiredModule="community"><CommunityVideoDetailPage /></ProtectedRoute> },
    
    // Feature Management routes (super-admin and operations-admin only)
    { path: "/feature-management", component: <ProtectedRoute requiredModule="featuremanagement"><FeaturesListPage /></ProtectedRoute> },
    { path: "/feature-management/features", component: <ProtectedRoute requiredModule="featuremanagement"><FeaturesListPage /></ProtectedRoute> },
    { path: "/feature-management/features/:name", component: <ProtectedRoute requiredModule="featuremanagement"><FeatureDetailPage /></ProtectedRoute> },
    { path: "/feature-management/feature-toggles", component: <ProtectedRoute requiredModule="featuremanagement"><FeatureTogglesListPage /></ProtectedRoute> },
    { path: "/feature-management/feature-toggles/:id", component: <ProtectedRoute requiredModule="featuremanagement"><FeatureToggleDetailPage /></ProtectedRoute> },
    
    
    // Shop Services routes (permission-based)
    {
        path: "/shop-services/sellers",
        component: (
            <ProtectedRoute
                requiredModule="sellers"
                anyOfPermissions={[
                    "shop.view",
                    "shop.admin",
                    "shop.seller.view",
                    "shop.seller.manage",
                ]}
            >
                <SellersPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/shop-services/sellers/:id",
        component: (
            <ProtectedRoute
                requiredModule="sellers"
                anyOfPermissions={[
                    "shop.view",
                    "shop.admin",
                    "shop.seller.view",
                    "shop.seller.manage",
                ]}
            >
                <SellerDetailPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/shop-services/sellers/locations/:id",
        component: (
            <ProtectedRoute
                requiredModule="sellers"
                anyOfPermissions={[
                    "shop.view",
                    "shop.admin",
                    "shop.seller.view",
                    "shop.seller.manage",
                ]}
            >
                <SellerLocationDetailPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/shop-services/products",
        component: (
            <ProtectedRoute
                requiredModule="products"
                anyOfPermissions={[
                    "shop.view",
                    "shop.admin",
                    "shop.product.view",
                    "shop.product.manage",
                ]}
            >
                <ProductsPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/shop-services/products/add",
        component: (
            <ProtectedRoute
                requiredModule="products"
                anyOfPermissions={[
                    "shop.view",
                    "shop.admin",
                    "shop.product.manage",
                ]}
            >
                <ProductDetail />
            </ProtectedRoute>
        ),
    },
    {
        path: "/shop-services/products/:id",
        component: (
            <ProtectedRoute
                requiredModule="products"
                anyOfPermissions={[
                    "shop.view",
                    "shop.admin",
                    "shop.product.view",
                    "shop.product.manage",
                ]}
            >
                <ProductDetail />
            </ProtectedRoute>
        ),
    },
    {
        path: "/shop-services/products/:id/edit",
        component: (
            <ProtectedRoute
                requiredModule="products"
                anyOfPermissions={[
                    "shop.view",
                    "shop.admin",
                    "shop.product.manage",
                ]}
            >
                <ProductDetail />
            </ProtectedRoute>
        ),
    },
    {
        path: "/shop-services/orders",
        component: (
            <ProtectedRoute
                requiredModule="orders"
                anyOfPermissions={[
                    "shop.view",
                    "shop.admin",
                    "shop.order.view",
                    "shop.order.manage",
                ]}
            >
                <OrdersPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/shop-services/orders/:orderId/:orderItemId",
        component: (
            <ProtectedRoute
                requiredModule="orders"
                anyOfPermissions={[
                    "shop.view",
                    "shop.admin",
                    "shop.order.view",
                    "shop.order.manage",
                ]}
            >
                <OrderDetail />
            </ProtectedRoute>
        ),
    },
    {
        path: "/shop-services/returns/:returnId",
        component: (
            <ProtectedRoute
                requiredModule="orders"
                anyOfPermissions={[
                    "shop.view",
                    "shop.admin",
                    "shop.order.view",
                    "shop.order.manage",
                ]}
            >
                <ReturnDetail />
            </ProtectedRoute>
        ),
    },
    { path: "/shop-services/cancellations/:orderId/:orderItemId", component: <ProtectedRoute requiredModule="orders"><CancelDetail /></ProtectedRoute> },
    
    // Promos routes (permission-based)
    { path: "/promos", component: <Navigate to="/promos/campaigns" replace /> },
    {
        path: "/promos/campaigns",
        component: (
            <ProtectedRoute
                requiredModule="promos"
                anyOfPermissions={[
                    "promo.view",
                    "promo.admin",
                    "promo.campaigns.view",
                    "promo.campaigns.manage",
                ]}
            >
                <CampaignsPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/promos/campaigns/create",
        component: (
            <ProtectedRoute
                requiredModule="promos"
                anyOfPermissions={[
                    "promo.admin",
                    "promo.campaigns.manage",
                ]}
            >
                <CreateCampaign />
            </ProtectedRoute>
        ),
    },
    {
        path: "/promos/campaigns/:id/detail",
        component: (
            <ProtectedRoute
                requiredModule="promos"
                anyOfPermissions={[
                    "promo.view",
                    "promo.admin",
                    "promo.campaigns.view",
                    "promo.campaigns.manage",
                ]}
            >
                <CampaignDetailPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/promos/campaigns/:id",
        component: (
            <ProtectedRoute
                requiredModule="promos"
                anyOfPermissions={[
                    "promo.view",
                    "promo.admin",
                    "promo.campaigns.view",
                    "promo.campaigns.manage",
                ]}
            >
                <CampaignDetailPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/promos/campaigns/:id/edit",
        component: (
            <ProtectedRoute
                requiredModule="promos"
                anyOfPermissions={[
                    "promo.admin",
                    "promo.campaigns.manage",
                ]}
            >
                <CreateCampaign />
            </ProtectedRoute>
        ),
    },
    
    // All Promos routes
    {
        path: "/promos/promos",
        component: (
            <ProtectedRoute
                requiredModule="promos"
                anyOfPermissions={["promo.view", "promo.admin"]}
            >
                <PromosPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/promos/promos/create",
        component: (
            <ProtectedRoute
                requiredModule="promos"
                anyOfPermissions={["promo.admin" ]}
            >
                <CreatePromo />
            </ProtectedRoute>
        ),
    },
    {
        path: "/promos/promos/:id/detail",
        component: (
            <ProtectedRoute
                requiredModule="promos"
                anyOfPermissions={["promo.view", "promo.admin"]}
            >
                <PromoDetailPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/promos/promos/:id",
        component: (
            <ProtectedRoute
                requiredModule="promos"
                anyOfPermissions={["promo.view", "promo.admin"]}
            >
                <PromoDetailPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/promos/promos/:id/edit",
        component: (
            <ProtectedRoute
                requiredModule="promos"
                anyOfPermissions={["promo.admin" ]}
            >
                <CreatePromo />
            </ProtectedRoute>
        ),
    },
    // Audit Logs route
    {
        path: "/promos/audit-logs",
        component: (
            <ProtectedRoute
                requiredModule="promos"
                anyOfPermissions={["promo.view", "promo.admin", "promo.audit_logs.view"]}
            >
                <AuditLogsPage />
            </ProtectedRoute>
        ),
    },

    // Ads routes (permission-based)
    { path: "/ads", component: <Navigate to="/ads/overview" replace /> },
    {
      path: "/ads/overview",
      component: (
        <ProtectedRoute
          requiredModule="ads"
          anyOfPermissions={["ads.view", "ads.admin", "ads.manage"]}
        >
          <AdsOverviewPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ads/advertisers",
      component: (
        <ProtectedRoute
          requiredModule="ads"
          anyOfPermissions={["ads.view", "ads.admin", "ads.manage"]}
        >
          <AdsAdvertisersPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ads/campaigns",
      component: (
        <ProtectedRoute
          requiredModule="ads"
          anyOfPermissions={["ads.view", "ads.admin", "ads.manage"]}
        >
          <AdsCampaignsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ads/campaigns/create",
      component: (
        <ProtectedRoute
          requiredModule="ads"
          anyOfPermissions={["ads.admin", "ads.manage"]}
        >
          <AdsCreateCampaignPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ads/campaigns/:id/edit",
      component: (
        <ProtectedRoute
          requiredModule="ads"
          anyOfPermissions={["ads.admin", "ads.manage"]}
        >
          <AdsCreateCampaignPage mode="edit" />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ads/campaigns/:id",
      component: (
        <ProtectedRoute
          requiredModule="ads"
          anyOfPermissions={["ads.view", "ads.admin", "ads.manage"]}
        >
          <AdsCreateCampaignPage mode="view" />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ads/creatives",
      component: (
        <ProtectedRoute
          requiredModule="ads"
          anyOfPermissions={["ads.view", "ads.admin", "ads.manage"]}
        >
          <AdsCreativesPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ads/creatives/:id/performance",
      component: (
        <ProtectedRoute
          requiredModule="ads"
          anyOfPermissions={["ads.view", "ads.admin", "ads.manage"]}
        >
          <AdsAdPerformancePage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ads/placements",
      component: (
        <ProtectedRoute
          requiredModule="ads"
          anyOfPermissions={["ads.view", "ads.admin", "ads.manage"]}
        >
          <AdsPlacementsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ads/reports",
      component: (
        <ProtectedRoute
          requiredModule="ads"
          anyOfPermissions={["ads.view", "ads.admin", "ads.manage"]}
        >
          <AdsReportsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ads/billing",
      component: (
        <ProtectedRoute
          requiredModule="ads"
          anyOfPermissions={["ads.view", "ads.admin", "ads.manage"]}
        >
          <AdsBillingPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ads/audit-logs",
      component: (
        <ProtectedRoute
          requiredModule="ads"
          anyOfPermissions={["ads.view", "ads.admin", "ads.manage"]}
        >
          <AdsAuditLogsPage />
        </ProtectedRoute>
      ),
    },

    // Legacy redirect for old shop-services promos route
    { path: "/shop-services/promos", component: <Navigate to="/promos/campaigns" replace /> },
    
    // Feature Management routes (permission-based)
    {
        path: "/feature-management",
        component: (
            <ProtectedRoute
                requiredModule="featuremanagement"
                anyOfPermissions={[
                    "feature_management.view",
                    "feature_management.admin",
                    "feature_management.features.view",
                    "feature_management.features.manage",
                ]}
            >
                <FeaturesListPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/feature-management/features",
        component: (
            <ProtectedRoute
                requiredModule="featuremanagement"
                anyOfPermissions={[
                    "feature_management.view",
                    "feature_management.admin",
                    "feature_management.features.view",
                    "feature_management.features.manage",
                ]}
            >
                <FeaturesListPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/feature-management/features/:name",
        component: (
            <ProtectedRoute
                requiredModule="featuremanagement"
                anyOfPermissions={[
                    "feature_management.view",
                    "feature_management.admin",
                    "feature_management.features.view",
                    "feature_management.features.manage",
                ]}
            >
                <FeatureDetailPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/feature-management/feature-toggles",
        component: (
            <ProtectedRoute
                requiredModule="featuretoggles"
                anyOfPermissions={[
                    "feature_management.view",
                    "feature_management.admin",
                    "feature_management.feature_toggles.view",
                    "feature_management.feature_toggles.manage",
                ]}
            >
                <FeatureTogglesListPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/feature-management/feature-toggles/:id",
        component: (
            <ProtectedRoute
                requiredModule="featuretoggles"
                anyOfPermissions={[
                    "feature_management.view",
                    "feature_management.admin",
                    "feature_management.feature_toggles.view",
                    "feature_management.feature_toggles.manage",
                ]}
            >
                <FeatureToggleDetailPage />
            </ProtectedRoute>
        ),
    },
    
    
    // Access Management routes (permission-based)
    {
        path: "/access-management/users",
        component: (
            <ProtectedRoute
                requiredModule="accessmanagement"
                anyOfPermissions={[
                    "access_management.view",
                    "access_management.admin",
                    "access_management.users.view",
                    "access_management.users.manage",
                ]}
            >
                <AccessManagementUsersPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/access-management/roles",
        component: (
            <ProtectedRoute
                requiredModule="accessmanagement"
                anyOfPermissions={[
                    "access_management.view",
                    "access_management.admin",
                    "access_management.roles.view",
                    "access_management.roles.manage",
                ]}
            >
                <AccessManagementRolesPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/access-management/permissions",
        component: (
            <ProtectedRoute
                requiredModule="accessmanagement"
                anyOfPermissions={[
                    "access_management.view",
                    "access_management.admin",
                    "access_management.permissions.view",
                    "access_management.permissions.manage",
                ]}
            >
                <AccessManagementPermissionsPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/audit-logs",
        component: (
            <ProtectedRoute
                requiredModule="accessmanagement"
                anyOfPermissions={[
                    "access_management.view",
                    "access_management.admin",
                    "access_management.audit_logs.view",
                ]}
            >
                <AccessManagementAuditLogsPage />
            </ProtectedRoute>
        ),
    },

    // Academy Enrolments routes
    {
        path: "/academy-enrolments",
        component: (
            <ProtectedRoute
                requiredModule="academyenrolments"
                anyOfPermissions={[
                    "academy_management.admin",
                    "academy_management.view",
                    "academy_management.enrollments.view",
                    "academy_management.enrollments.manage",
                ]}
            >
                <AcademyEnrolmentsPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/academy-enrolments/add",
        component: (
            <ProtectedRoute
                requiredModule="academyenrolments"
                anyOfPermissions={[
                    "academy_management.admin",
                    "academy_management.enrollments.manage",
                ]}
            >
                <AddEnrolmentPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/academy-enrolments/:id",
        component: (
            <ProtectedRoute
                requiredModule="academyenrolments"
                anyOfPermissions={[
                    "academy_management.admin",
                    "academy_management.view",
                    "academy_management.enrollments.view",
                    "academy_management.enrollments.manage",
                ]}
            >
                <EnrolmentDetailsPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/academy-trials/add",
        component: (
            <ProtectedRoute
                requiredModule="academytrialadd"
                anyOfPermissions={TRIALS_MANAGE_PERMS}
            >
                <AddTrialPage />
            </ProtectedRoute>
        ),
    },
    {
        path: "/academy-course-assignments",
        component: (
            <ProtectedRoute
                requiredModule="academycourseassignments"
                anyOfPermissions={[
                    "academy_management.admin",
                    "academy_management.view",
                    "academy_management.enrollments.view",
                    "academy_management.enrollments.manage",
                ]}
            >
                <CourseAssignmentsPage />
            </ProtectedRoute>
        ),
    },

    // All Clubs routes (admin only)
    {
        path: "/all-clubs",
        component: (
            <ProtectedRoute
                requiredModule="allclubs"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "tournament.view",
                    "tournament.read",
                    "tournament.registrations.view",
                    "tournament.registrations.manage",
                    "club.read",
                    "club.manage",
                ]}
            >
                <AllClubs />
            </ProtectedRoute>
        ),
    },
    {
        path: "/all-clubs/add",
        component: (
            <ProtectedRoute
                requiredModule="allclubs"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "club.manage",
                ]}
            >
                <AddClubDetails />
            </ProtectedRoute>
        ),
    },
    {
        path: "/all-clubs/:clubId",
        component: (
            <ProtectedRoute
                requiredModule="allclubs"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "tournament.view",
                    "tournament.read",
                    "tournament.registrations.view",
                    "tournament.registrations.manage",
                    "club.read",
                    "club.manage",
                ]}
            >
                <ClubDetails />
            </ProtectedRoute>
        ),
    },
    {
        path: "/all-clubs/:clubId/team/:teamId/players",
        component: (
            <ProtectedRoute
                requiredModule="allclubs"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "club.manage",
                    "tournament.players.manage",
                ]}
            >
                <ClubPlayerManagement />
            </ProtectedRoute>
        ),
    },
    
    // Manage Players routes (super-admin and operations-admin only)
    {
        path: "/manage-players",
        component: (
            <ProtectedRoute
                requiredModule="manageplayers"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "tournament.view",
                    "tournament.read",
                    "tournament.registrations.view",
                    "tournament.registrations.manage",
                    "tournament.players.view",
                    "tournament.players.manage",
                ]}
            >
                <ManagePlayers />
            </ProtectedRoute>
        ),
    },
    {
        path: "/manage-players/:playerId",
        component: (
            <ProtectedRoute
                requiredModule="manageplayers"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "tournament.registrations.manage",
                    "tournament.players.manage",
                ]}
            >
                <ManagePlayerDetail />
            </ProtectedRoute>
        ),
    },
    
    // Manage Tournaments routes (super-admin and operations-admin only)
    {
        path: "/sports-management",
        component: (
            <ProtectedRoute
                requiredModule="sportsmanagement"
                anyOfPermissions={["sports_management.view", "sports_management.manage"]}
            >
                <SportsManagement />
            </ProtectedRoute>
        ),
    },
    {
        path: "/manage-tournaments",
        component: (
            <ProtectedRoute
                requiredModule="managetournaments"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "tournament.read",
                    "tournament.registrations.view",
                    "tournament.registrations.manage",
                    "tournament.tournaments.view",
                    "tournament.tournaments.manage",
                ]}
            >
                <ManageTournaments />
            </ProtectedRoute>
        ),
    }, // legacy
    {
        path: "/manage-tournaments/:id",
        component: (
            <ProtectedRoute
                requiredModule="managetournaments"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "tournament.registrations.manage",
                    "tournament.tournaments.manage",
                ]}
            >
                <TournamentDetailView />
            </ProtectedRoute>
        ),
    }, // legacy
    // New alias routes for clarity
    {
        path: "/tournaments-listing",
        component: (
            <ProtectedRoute
                requiredModule="managetournaments"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "tournament.view",
                    "tournament.read",
                    "tournament.registrations.view",
                    "tournament.registrations.manage",
                    "tournament.tournaments.view",
                    "tournament.tournaments.manage",
                ]}
            >
                <ManageTournaments />
            </ProtectedRoute>
        ),
    },
    {
        path: "/tournaments-listing/:id",
        component: (
            <ProtectedRoute
                requiredModule="managetournaments"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "tournament.registrations.manage",
                    "tournament.tournaments.manage",
                ]}
            >
                <TournamentDetailView />
            </ProtectedRoute>
        ),
    },
    {
        path: "/tournaments-listing/add",
        component: (
            <ProtectedRoute
                requiredModule="managetournaments"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "tournament.registrations.manage",
                    "tournament.tournaments.manage",
                ]}
            >
                <TournamentDetailView />
            </ProtectedRoute>
        ),
    },
    // Legacy add path retained
    {
        path: "/manage-tournaments/add",
        component: (
            <ProtectedRoute
                requiredModule="managetournaments"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.tournaments.manage",
                ]}
            >
                <TournamentDetailView />
            </ProtectedRoute>
        ),
    },
    
    // Registered Tournaments routes (super-admin and operations-admin only)
    {
        path: "/registered-tournaments",
        component: (
            <ProtectedRoute
                requiredModule="registeredtournaments"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "tournament.view",
                    "tournament.read",
                    "tournament.registrations.view",
                    "tournament.registrations.manage",
                    "tournament.registration_details.manage",
                ]}
            >
                <RegisteredTournaments />
            </ProtectedRoute>
        ),
    },
    {
        path: "/registered-tournaments/:id",
        component: (
            <ProtectedRoute
                requiredModule="registeredtournaments"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "tournament.view",
                    "tournament.read",
                    "tournament.registrations.view",
                    "tournament.registrations.manage",
                    "tournament.registration_details.manage",
                ]}
            >
                <RegisteredTournamentDetail />
            </ProtectedRoute>
        ),
    },
    {
        path: "/registered-tournaments/:id/teams/:teamId/players",
        component: (
            <ProtectedRoute
                requiredModule="registeredtournaments"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "tournament.view",
                    "tournament.read",
                    "tournament.registrations.manage",
                    "tournament.registration_details.manage",
                    "tournament.players.manage",
                ]}
            >
                <PlayerManagement />
            </ProtectedRoute>
        ),
    },
    {
        path: "/registered-tournaments/:id/teams/:teamId/record-payment",
        component: (
            <ProtectedRoute
                requiredModule="registeredtournaments"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "tournament.view",
                    "tournament.read",
                    "tournament.registrations.manage",
                    "tournament.registration_details.manage",
                    "tournament.payments.view",
                ]}
            >
                <RecordPaymentPage />
            </ProtectedRoute>
        ),
    },
    
    // Tournament routes (permission-based)
    { path: "/tournament-details", component: <ProtectedRoute requiredModule="tournamentdetails" anyOfPermissions={["tournament.admin","tournament.manage","tournament.view","tournament.read"]}><TournamentDetails /></ProtectedRoute> },
    { path: "/tournament-details/overview", component: <ProtectedRoute requiredModule="tournamentdetails" anyOfPermissions={["tournament.admin","tournament.manage","tournament.view","tournament.read"]}><TournamentDetails /></ProtectedRoute> },
    { path: "/tournament-details/age-category", component: <ProtectedRoute requiredModule="tournamentdetails" anyOfPermissions={["tournament.admin","tournament.manage","tournament.view","tournament.read"]}><TournamentDetails /></ProtectedRoute> },
    { path: "/tournament-details/:id", component: <ProtectedRoute requiredModule="tournamentdetails" anyOfPermissions={["tournament.admin","tournament.manage","tournament.view","tournament.read"]}><TournamentDetailsPage /></ProtectedRoute> },
    { path: "/tournament-details/tournaments", component: <ProtectedRoute requiredModule="tournamentdetails" anyOfPermissions={["tournament.admin","tournament.manage","tournament.view","tournament.read"]}><TournamentDetails /></ProtectedRoute> },
    { path: "/tournaments", component: <ProtectedRoute requiredModule="tournaments" anyOfPermissions={["tournament.admin","tournament.manage","tournament.view","tournament.read"]}><TournamentsPage /></ProtectedRoute> },
    { path: "/tournaments/:id", component: <ProtectedRoute requiredModule="tournaments" anyOfPermissions={["tournament.admin","tournament.manage","tournament.view","tournament.read"]}><TournamentDetail /></ProtectedRoute> },
    { path: "/tournaments/:id/register", component: <ProtectedRoute requiredModule="tournaments" anyOfPermissions={["tournament.admin","tournament.manage","tournament.view","tournament.read"]}><TeamRegistration /></ProtectedRoute> },
    { path: "/tournaments/:id/teams/:teamId/players", component: <ProtectedRoute requiredModule="tournaments" anyOfPermissions={["tournament.admin","tournament.manage","tournament.view","tournament.read","tournament.players.view","tournament.players.manage"]}><PlayerManagement /></ProtectedRoute> },
    { path: "/tournaments/:id/teams/:teamId/payments", component: <ProtectedRoute requiredModule="tournaments" anyOfPermissions={["tournament.admin","tournament.manage","tournament.view","tournament.read","tournament.payments.view"]}><PaymentPage /></ProtectedRoute> },
    { path: "/tournaments/:id/payment", component: <ProtectedRoute requiredModule="tournaments" anyOfPermissions={["tournament.admin","tournament.manage","tournament.view","tournament.read","tournament.payments.view"]}><PaymentPage /></ProtectedRoute> },
    { path: "/tournaments/registered/:id", component: <ProtectedRoute requiredModule="tournaments" anyOfPermissions={["tournament.admin","tournament.manage","tournament.view","tournament.read"]}><RegisteredTournamentDetail /></ProtectedRoute> },
    
    // My Club Routes (permission-based)
    { path: "/my-club", component: <ProtectedRoute requiredModule="myclub" anyOfPermissions={["club.read","club.manage"]}><MyClub /></ProtectedRoute> },
    { path: "/my-club/team-information", component: <ProtectedRoute requiredModule="myclub" anyOfPermissions={["club.read","club.manage"]}><TeamInformation /></ProtectedRoute> },
    { path: "/my-club/team-information/:teamId", component: <ProtectedRoute requiredModule="myclub" anyOfPermissions={["club.read","club.manage"]}><TeamDetail /></ProtectedRoute> },
    { path: "/my-club/team-information/:teamId/players", component: <ProtectedRoute requiredModule="myclub" anyOfPermissions={["club.read","club.manage","tournament.players.view","tournament.players.manage"]}><PlayerManagement /></ProtectedRoute> },
    { path: "/my-club/player-information/add", component: <ProtectedRoute requiredModule="myclub" anyOfPermissions={["club.read","club.manage","tournament.players.manage"]}><AddPlayer /></ProtectedRoute> },
    { path: "/my-club/player-information/:playerId", component: <ProtectedRoute requiredModule="myclub" anyOfPermissions={["club.read","club.manage","tournament.players.view","tournament.players.manage"]}><PlayerDetail /></ProtectedRoute> },
    { path: "/my-club/player-information", component: <ProtectedRoute requiredModule="myclub" anyOfPermissions={["club.read","club.manage","tournament.players.view","tournament.players.manage"]}><PlayerInformation /></ProtectedRoute> },
    { path: "/my-club/club-information", component: <ProtectedRoute requiredModule="myclub" anyOfPermissions={["club.read","club.manage"]}><ClubInformation /></ProtectedRoute> },

    // Payment & Transactions Routes (permission-based: payments-specific only)
    { path: "/payment-transactions", component: <ProtectedRoute requiredModule="paymenttransactions" anyOfPermissions={["tournament.payments.view","tournament.view","tournament.read"]}><Dues /></ProtectedRoute> },
    { path: "/payment-transactions/dues", component: <ProtectedRoute requiredModule="paymenttransactions" anyOfPermissions={["tournament.payments.view","tournament.view","tournament.read"]}><Dues /></ProtectedRoute> },
    { path: "/payment-transactions/dues/:dueId", component: <ProtectedRoute requiredModule="paymenttransactions" anyOfPermissions={["tournament.payments.view","tournament.view","tournament.read"]}><DueDetail /></ProtectedRoute> },
    { path: "/payment-transactions/transactions", component: <ProtectedRoute requiredModule="paymenttransactions" anyOfPermissions={["tournament.payments.view","tournament.view","tournament.read"]}><Transactions /></ProtectedRoute> },
    
    // Super Admin Payments & Transactions Routes (accessible by super admin and operations admin)
    {
        path: "/super-admin-payments",
        component: (
            <ProtectedRoute
                requiredModule="superadminpayments"
                anyOfPermissions={[
                    "tournament.admin",
                    "tournament.manage",
                    "tournament.registrations.view",
                    "tournament.registrations.manage",
                    "tournament.payments.view",
                    "tournament.view",
                    "tournament.read",
                ]}
            >
                <SuperAdminPayments />
            </ProtectedRoute>
        ),
    },
    
    // Fixtures Routes (accessible by super admin and operations admin) - Legacy
  { path: "/fixtures/*", component: <Navigate to="/manage-tournaments-fixtures" replace /> },
  
      // Age Category Fixtures Routes - Legacy
      { path: "/fixtures/age-category", component: <ProtectedRoute requiredModule="fixtures"><AgeCategoryListingPage /></ProtectedRoute> },
      { path: "/fixtures/age-category/add", component: <ProtectedRoute requiredModule="fixtures"><AddAgeCategoryFixturePage /></ProtectedRoute> },
      { path: "/fixtures/age-category/edit", component: <ProtectedRoute requiredModule="fixtures"><AddAgeCategoryFixturePage /></ProtectedRoute> },

  // New Manage Tournaments Fixtures Routes (accessible by super admin, operations admin, tournament.view, and tournament.read)
  { path: "/manage-tournaments-fixtures", component: <ProtectedRoute requiredModule="managetournamentsfixtures" anyOfPermissions={["tournament.admin","tournament.tournaments.view","tournament.tournaments.manage","tournament.fixtures.manage","tournament.view","tournament.read"]}><ManageTournamentsFixturesPage /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/add", component: <ProtectedRoute requiredModule="managetournamentsfixtures" anyOfPermissions={["tournament.admin","tournament.tournaments.view","tournament.tournaments.manage","tournament.fixtures.manage","tournament.view","tournament.read"]}><AddFixturePage /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/:tournamentId/seasons", component: <ProtectedRoute requiredModule="managetournamentsfixtures" anyOfPermissions={["tournament.admin","tournament.tournaments.view","tournament.tournaments.manage","tournament.fixtures.manage","tournament.view","tournament.read"]}><SeasonsListingPage /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/:tournamentId/seasons/:seasonId/videos/create", component: <ProtectedRoute requiredModule="managetournamentsfixtures" requireTournamentAccess anyOfPermissions={["tournament.admin","tournament.tournaments.manage","tournament.fixtures.manage"]}><TournamentVideoDetailPage mode="create" /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/:tournamentId/seasons/:seasonId/videos/:videoId/edit", component: <ProtectedRoute requiredModule="managetournamentsfixtures" requireTournamentAccess anyOfPermissions={["tournament.admin","tournament.tournaments.manage","tournament.fixtures.manage"]}><TournamentVideoDetailPage mode="edit" /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/:tournamentId/seasons/:seasonId/videos/:videoId", component: <ProtectedRoute requiredModule="managetournamentsfixtures" requireTournamentAccess anyOfPermissions={["tournament.admin","tournament.tournaments.view","tournament.tournaments.manage","tournament.fixtures.manage","tournament.view","tournament.read"]}><TournamentVideoDetailPage mode="view" /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/:tournamentId/seasons/:seasonId/gallery/albums/:albumId", component: <ProtectedRoute requiredModule="managetournamentsfixtures" requireTournamentAccess anyOfPermissions={["tournament.admin","tournament.tournaments.manage","tournament.fixtures.manage"]}><GalleryAlbumDetailPage /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/:tournamentId/seasons/:seasonId/ties/:ageCategoryId", component: <ProtectedRoute requiredModule="managetournamentsfixtures" requireTournamentAccess anyOfPermissions={["tournament.admin","tournament.tournaments.manage","tournament.fixtures.manage"]}><BadmintonTiesPage /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/:tournamentId/seasons/:seasonId", component: <ProtectedRoute requiredModule="managetournamentsfixtures" requireTournamentAccess anyOfPermissions={["tournament.admin","tournament.tournaments.view","tournament.tournaments.manage","tournament.fixtures.manage","tournament.view","tournament.read"]}><SeasonDetailPage /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/:id", component: <ProtectedRoute requiredModule="managetournamentsfixtures" requireTournamentAccess anyOfPermissions={["tournament.admin","tournament.tournaments.view","tournament.tournaments.manage","tournament.fixtures.manage","tournament.view","tournament.read"]}><TournamentDetailPage /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/:tournamentId/seasons/:seasonId/player-stats/:playerId", component: <ProtectedRoute requiredModule="managetournamentsfixtures" requireTournamentAccess anyOfPermissions={["tournament.admin","tournament.tournaments.view","tournament.tournaments.manage","tournament.fixtures.manage","tournament.view","tournament.read"]}><PlayerStatsDetailPage /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/:id/player-stats/:playerId", component: <ProtectedRoute requiredModule="managetournamentsfixtures" requireTournamentAccess anyOfPermissions={["tournament.admin","tournament.tournaments.view","tournament.tournaments.manage","tournament.fixtures.manage","tournament.view","tournament.read"]}><PlayerStatsDetailPage /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/:id/match/:matchId", component: <ProtectedRoute requiredModule="managetournamentsfixtures" anyOfPermissions={["tournament.admin","tournament.tournaments.view","tournament.tournaments.manage","tournament.fixtures.manage","tournament.view","tournament.read"]}><MatchDetailPage /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/:id/edit", component: <ProtectedRoute requiredModule="managetournamentsfixtures" anyOfPermissions={["tournament.admin","tournament.tournaments.view","tournament.tournaments.manage","tournament.fixtures.manage","tournament.view","tournament.read"]}><TournamentDetailPage /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/:fixtureId/add-group", component: <ProtectedRoute requiredModule="managetournamentsfixtures" anyOfPermissions={["tournament.admin","tournament.tournaments.view","tournament.tournaments.manage","tournament.fixtures.manage","tournament.view","tournament.read"]}><AddGroupPage /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/:fixtureId/groups/:groupId/fixtures", component: <ProtectedRoute requiredModule="fixtures" anyOfPermissions={["tournament.admin","tournament.tournaments.view","tournament.tournaments.manage","tournament.fixtures.manage","tournament.view","tournament.read"]}><GroupFixturesEditPage /></ProtectedRoute> },
  { path: "/manage-tournaments-fixtures/:fixtureId/add-fixtures", component: <ProtectedRoute requiredModule="managetournamentsfixtures" anyOfPermissions={["tournament.admin","tournament.tournaments.view","tournament.tournaments.manage","tournament.fixtures.manage","tournament.view","tournament.read"]}><AddIndividualFixturesPage /></ProtectedRoute> },
  
      // Age Category Fixtures Routes - New
      { path: "/manage-tournaments-fixtures/age-category", component: <ProtectedRoute requiredModule="managetournamentsfixtures"><AgeCategoryListingPage /></ProtectedRoute> },
      { path: "/manage-tournaments-fixtures/age-category/add", component: <ProtectedRoute requiredModule="managetournamentsfixtures"><AddAgeCategoryFixturePage /></ProtectedRoute> },
      { path: "/manage-tournaments-fixtures/age-category/edit", component: <ProtectedRoute requiredModule="managetournamentsfixtures"><AddAgeCategoryFixturePage /></ProtectedRoute> },
      
      // Standings Detail Routes
      { path: "/manage-tournaments-fixtures/standings/single/:tournamentId/:ageCategoryId", component: <ProtectedRoute requiredModule="managetournamentsfixtures"><SingleStandingsDetailPage /></ProtectedRoute> },
      { path: "/manage-tournaments-fixtures/standings/group/:tournamentId/:ageCategoryId", component: <ProtectedRoute requiredModule="managetournamentsfixtures"><GroupStandingsDetailPage /></ProtectedRoute> },
      { path: "/manage-tournaments-fixtures/standings/knockouts/:tournamentId/:ageCategoryId", component: <ProtectedRoute requiredModule="managetournamentsfixtures"><KnockoutsDetailPage /></ProtectedRoute> },
      { path: "/manage-tournaments-fixtures/standings/group-detail/:tournamentId/:ageCategoryId/:groupName", component: <ProtectedRoute requiredModule="managetournamentsfixtures"><GroupDetailPage /></ProtectedRoute> },
    
    // Player Vault routes
    { path: "/player-vault", component: <Navigate to="/player-vault/claim-requests" replace /> },
    { path: "/player-vault/claim-requests", component: <ClaimRequestsPage /> },

    // User profile (accessible by all authenticated users)
    { path: "/user-profile", component: <UserProfile /> },
    
    // Default routes - redirect based on role
    { path: "/", exact: true, component: <RoleBasedDashboard /> },
    { path: "*", component: <RoleBasedDashboard /> },

];

const publicRoutes = [
    // Authentication
    { path: "/login", name : "Login" ,component: <Login /> },
    { path: "/logout", name : "Logout" ,component: <Logout /> },
    { path: "/register", name : "Register" ,component: <Register /> },
    { path: "/forgot-password", name : "ForgotPassword" ,component: <ForgotPassword /> },


    // Error
    // Error 404
    { path: "/auth-404", name : "Fourzerofour" ,component: <Fourzerofour /> },

    // Error 500
    { path: "/auth-500", name : "Fivezerozero" ,component: <Fivezerozero /> },

    // Error 503
    { path: "/auth-503", name : "Fivezerothree" ,component: <Fivezerothree /> },

    // Offline Page
    { path: "/auth-offline", name : "OfflinePage" ,component: <OfflinePage /> },

];

export { authProtectedRoutes, publicRoutes };